// The max size limit for AWS pre-signed URLs is 5Gb.
// Uploading a file over 5Gb will fail silently because
// the pre-signing will error but the frontend will not
// prevent such a file from being uploaded.
// See: https://aws.amazon.com/s3/faqs/#:~:text=Individual%20Amazon%20S3%20objects%20can,using%20the%20multipart%20upload%20capability
export const MAX_UPLOAD_SIZE = 1024 ** 3 * 5;
